import { useEffect, ComponentType } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router";

ReactGA.initialize("G-ENSWN7Q793");

export default function withTracker<P extends object>(
  WrappedComponent: ComponentType<P>,
  options: Record<string, unknown> = {}
): ComponentType<P> {
  const HOC = (props: P) => {
    const location = useLocation();

    useEffect(() => {
      ReactGA.send({ hitType: "pageview", page: location.pathname, ...options });
    }, [location.pathname]);

    return <WrappedComponent {...props} />;
  };

  return HOC;
}
